export const songs = [
  {
    id: "21",
    number: 21,
    date: "2026-05-22",
    title: "Creep",
    artist: "Radiohead",
    link: "https://www.youtube.com/embed/",
    style: "",
    lyricsOriginal: [
      `When you were here before
Couldn't look you in the eye
You're just like an angel
Your skin makes me cry
You float like a feather
In a beautiful world
I wish I was special
You're so fucking special`,

      `But I'm a creep
I'm a weirdo
What the hell am I doing here?
I don't belong here`,

      `I don't care if it hurts
I want to have control
I want a perfect body
I want a perfect soul
I want you to notice
When I'm not around
You're so fucking special
I wish I was special`,

      `But I'm a creep
I'm a weirdo
What the hell am I doing here?
I don't belong here`,

      `She's running out again
She's running out
She run, run, run, run
Run`,

      `Whatever makes you happy
Whatever you want
You're so fucking special
I wish I was special`,

      `But I'm a creep
I'm a weirdo
What the hell am I doing here?
I don't belong here
I don't belong here`,
    ],
    lyricsModified: [],
  },
  {
    id: "20",
    number: 20,
    date: "2026-05-21",
    title: "Levitating",
    artist: "Dua Lipa",
    link: "https://www.youtube.com/embed/TUVcZfQe-Kw",
    style: "Magician's Spellbinding Patter",
    lyricsOriginal: [
      `If you wanna run away with me, I know a galaxy
And I can take you for a ride
I had a premonition that we fell into a rhythm
Where the music don't stop for life
Glitter in the sky, glitter in my eyes
Shining just the way I like
If you're feeling like you need a little bit of company
You met me at the perfect time`,

      `You want me, I want you, baby
My sugarboo, I'm levitating
The Milky Way, we're renegading
Yeah, yeah, yeah, yeah, yeah`,

      `I got you, moonlight, you're my starlight
I need you all night, come on, dance with me
I'm levitating
You, moonlight, you're my starlight (You're the moonlight)
I need you all night, come on, dance with me
I'm levitating`,

      `I believe that you're for me, I feel it in our energy
I see us written in the stars
We can go wherever, so let's do it now or never
Baby, nothing's ever, ever too far
Glitter in the sky, glitter in our eyes
Shining just the way we are
I feel like we're forever every time we get together
But whatever, let's get lost on Mars`,

      `You want me, I want you, baby
My sugarboo, I'm levitating
The Milky Way, we're renegading
Yeah, yeah, yeah, yeah, yeah`,

      `I got you, moonlight, you're my starlight
I need you all night, come on, dance with me
I'm levitating
You, moonlight, you're my starlight (You're the moonlight)
I need you all night, come on, dance with me
I'm levitating`,

      `You can fly away with me tonight
You can fly away with me tonight
Baby, let me take you for a ride
Yeah, yeah, yeah, yeah, yeah
I'm levitating (Woo)
You can fly away with me tonight
You can fly away with me tonight
Baby, let me take you for a ride
Yeah, yeah, yeah, yeah, yeah (Woo)`,

      `My love is like a rocket, watch it blast off
And I'm feeling so electric, dance my ass off
And even if I wanted to, I can't stop
Yeah, yeah, yeah, yeah, yeah
My love is like a rocket, watch it blast off
And I'm feeling so electric, dance my ass off
And even if I wanted to, I can't stop
Yeah, yeah, yeah, yeah, yeah`,

      `You want me, I want you, baby
My sugarboo, I'm levitating
The Milky Way, we're renegading`,

      `I got you (Yeah), moonlight, you're my starlight
I need you all night (All night), come on, dance with me
I'm levitating (Woo)`,

      `You can fly away with me tonight (Tonight)
You can fly away with me tonight
Baby, let me take you for a ride
Yeah, yeah, yeah, yeah, yeah (Take you for a ride)
I'm levitating (Woo)
You can fly away with me tonight (Tonight)
You can fly away with me tonight
Baby, let me take you for a ride
Yeah, yeah, yeah, yeah, yeah (Let me take you for a ride)`,

      `I got you, moonlight, you're my starlight (You are my starlight)
I need you all night, come on, dance with me (Come on, dance with me)
I'm levitating
You, moonlight, you're my starlight (You're the moonlight)
I need you all night, come on, dance with me
I'm levitating`,
    ],
    lyricsModified: [
      `Should your heart crave escape, I hold the portal key —
A realm of stars awaits your leap!
I foresaw this moment: two souls caught in cadence,
Where the rhythm enchants, eternal and deep.
Glimmers above, twinkles in your gaze —
Aligned just as the prophecy said.
If loneliness haunts your night with whispers,
You've summoned me — right when the stars turned red.`,

      `Desire dances in your eyes — and mine,
Sugarbound, we begin to rise!
Through the galaxies we defy the rules,
Vanishing into the velvet skies — yes, yes, yes!`,

      `I conjure you, moonbeam — you're my northern light.
Stay 'til dawn — let the enchantment ignite!
We float, we twirl — we’re levitating.
You, moonbeam, a sorcerer's delight —
Stay 'til dawn — let the music invite!
We spin in the stars — no hesitating.`,

      `You were fated for this — it buzzes in our aura.
The cosmos wrote our names in gold.
We could vanish now, no maps, no limits —
Everywhere’s reachable when you’re bold.
Glimmers above, sparkles in our stare —
Exactly how we were meant to glow.
Time bends around us when we meet again —
Forget logic — let’s disappear to Mars, you know?`,

      `Desire dances in your eyes — and mine,
Sugarbound, we begin to rise!
Through the galaxies we defy the rules,
Vanishing into the velvet skies — yes, yes, yes!`,

      `I conjure you, moonbeam — you're my northern light.
Stay 'til dawn — let the enchantment ignite!
We float, we twirl — we’re levitating.
You, moonbeam, a sorcerer's delight —
Stay 'til dawn — let the music invite!
We spin in the stars — no hesitating.`,

      `You can rise with me tonight — no broomstick needed!
Take flight — a velvet-charmed ride!
Yes, yes — let the levitation begin! (Abracadabra!)
Come now, glide with me tonight —
With a flick of the wrist, we'll disappear right.
Yes, yes — let the sorcery spin! (Alakazam!)`,

      `My love’s a firework — stand back, watch it soar!
Buzzing like a wand — can't stop this uproar!
Even if I tried — the spell is sealed,
Yes, yes — no going back for sure!
My love’s a rocket — three, two, one, ignite!
Buzzing with volts — I vanish in light!
Even if I wished it, I can’t undo —
Yes, yes — the magic clings like glue.`,

      `Desire dances in your eyes — and mine,
Sugarbound, we begin to rise!
Through the galaxies we defy the rules —
Vanishing into the velvet skies.`,

      `I conjure you (oh yes), moonlight — my radiant spark!
All through the night (so bright), come sway with the arc!
We’re levitating now — up, up, and away! (Hocus pocus!)`,

      `Come, lift off into mystery tonight (tonight!)
Let’s vanish beneath the twilight!
Yes, yes — I’ll be your guide!
I’m levitating (woo!)
Soar with me through the endless dark (tonight!)
I’ll whisk you on a cosmic arc!
Yes, yes — let wonder be our ride! (Let me take you for a ride!)`,

      `I’ve got you, moonlight — you dazzle like fate!
I need your shine — now don’t hesitate!
Join me in the sky — we’re levitating.
You, moonlight — you mystical thing!
Let’s float, let’s spin, let the stardust sing!
We’re drifting higher — no gravitating.`,
    ],
  },
  {
    id: "19",
    number: 19,
    date: "2026-05-20",
    title: "Shape of You",
    artist: "Ed Sheeran",
    link: "https://www.youtube.com/embed/JGwWNGJdvx8",
    style: "Retro 80s Commercial",
    lyricsOriginal: [
      `The club isn't the best place to find a lover
So the bar is where I go
Me and my friends at the table doing shots
Drinking fast and then we talk slow
And you come over and start up a conversation with just me
And trust me I'll give it a chance now
Take my hand, stop, put Van The Man on the jukebox
And then we start to dance
And now I'm singing like`,

      `Girl, you know I want your love
Your love was handmade for somebody like me
Come on now, follow my lead
I may be crazy, don't mind me
Say, boy, let's not talk too much
Grab on my waist and put that body on me
Come on now, follow my lead
Come, come on now, follow my lead`,

      `I'm in love with the shape of you
We push and pull like a magnet do
Although my heart is falling too
I'm in love with your body
Last night you were in my room
And now my bedsheets smell like you
Every day discovering something brand new
I'm in love with your body`,

      `Oh I oh I oh I oh I
I'm in love with your body
Oh I oh I oh I oh I
I'm in love with your body
Oh I oh I oh I oh I
I'm in love with your body
Every day discovering something brand new
I'm in love with the shape of you`,

      `One week in we let the story begin
We're going out on our first date
You and me are thrifty, so go all you can eat
Fill up your bag and I fill up a plate
We talk for hours and hours about the sweet and the sour
And how your family is doing okay
And leave and get in a taxi, then kiss in the backseat
Tell the driver make the radio play
And I'm singing like`,

      `Girl, you know I want your love
Your love was handmade for somebody like me
Come on now, follow my lead
I may be crazy, don't mind me
Say, boy, let's not talk too much
Grab on my waist and put that body on me
Come on now, follow my lead
Come, come on now, follow my lead`,

      `I'm in love with the shape of you
We push and pull like a magnet do
Although my heart is falling too
I'm in love with your body
Last night you were in my room
And now my bedsheets smell like you
Every day discovering something brand new
I'm in love with your body`,

      `Oh I oh I oh I oh I
I'm in love with your body
Oh I oh I oh I oh I
I'm in love with your body
Oh I oh I oh I oh I
I'm in love with your body
Every day discovering something brand new
I'm in love with the shape of you`,

      `Come on, be my baby, come on
Come on, be my baby, come on
Come on, be my baby, come on
Come on, be my baby, come on
Come on, be my baby, come on
Come on, be my baby, come on
Come on, be my baby, come on
Come on, be my baby, come on`,

      `I'm in love with the shape of you
We push and pull like a magnet do
Although my heart is falling too
I'm in love with your body
Last night you were in my room
And now my bedsheets smell like you
Every day discovering something brand new
I'm in love with your body`,

      `Come on, be my baby, come on
Come on, be my baby, come on
I'm in love with your body
Come on, be my baby, come on
Come on, be my baby, come on
I'm in love with your body
Come on, be my baby, come on
Come on, be my baby, come on
I'm in love with your body
Every day discovering something brand new
I'm in love with the shape of you`,
    ],
    lyricsModified: [
      `The nightclub? Not ideal for sparks to fly.
You want real chemistry? Head to your local bar!
Grab your pals, round up some shots!
Sip quick — but speak smooth.
Then someone strolls up, just chatting with you,
Give 'em a shot — it's a once-in-a-lifetime deal!
Take their hand, spin that jukebox magic,
Cue a classic, let the rhythm lead,
And suddenly — boom — you're singing along.`,

      `Hey there, you're chasing that custom-made affection.
That handcrafted kind, tailor-fit to your vibe.
Step up, follow where the fun flows.
A little wild? That's part of the thrill.
Let’s skip the chatter, skip the scripts,
Just hold on tight, feel the spark.
No overthinking — just go with the beat.
Yeah, lean in, just follow that groove.`,

      `You're vibing with their silhouette, no doubt.
You two click — push and pull like magic.
Even your heart’s syncing up to the rhythm.
You’re drawn in, totally hooked.
Last night, they were chillin' in your space.
Now everything smells like "them" — wild, right?
Each day? A brand-new chapter.
You’re head-over-heels for their whole vibe.`,

      `Whoa now, whoa now, slow that roll —
You’re all in on the silhouette.
Whoa now, whoa now, can't shake it —
That body’s got you hypnotized.
Whoa now, whoa now, it’s magnetic —
You're loving every bit.
New feels every morning, like clockwork.
Yeah, you're sold on the whole design.`,

      `Seven days in, you're living the movie.
First official date night? Let’s gooo!
You're frugal — buffet? Say no more!
Fill your tote, pile your plate — win-win!
Chit-chat all night — sweet stuff, sour stuff,
Family updates, deep dives — it’s real!
Then roll out in a taxi, smooch in the back,
Tell the driver: crank those jams!
And boom — that song hits, you're feelin’ it.`,

      `Hey there, you're chasing that custom-made affection.
That handcrafted kind, tailor-fit to your vibe.
Step up, follow where the fun flows.
A little wild? That's part of the thrill.
Let’s skip the chatter, skip the scripts,
Just hold on tight, feel the spark.
No overthinking — just go with the beat.
Yeah, lean in, just follow that groove.`,

      `You're vibing with their silhouette, no doubt.
You two click — push and pull like magic.
Even your heart’s syncing up to the rhythm.
You’re drawn in, totally hooked.
Last night, they were chillin' in your space.
Now everything smells like "them" — wild, right?
Each day? A brand-new chapter.
You’re head-over-heels for their whole vibe.`,

      `Whoa now, whoa now, slow that roll —
You’re all in on the silhouette.
Whoa now, whoa now, can't shake it —
That body’s got you hypnotized.
Whoa now, whoa now, it’s magnetic —
You're loving every bit.
New feels every morning, like clockwork.
Yeah, you're sold on the whole design.`,

      `Come on — be bold, take that shot!
Come on — be bold, take that shot!
Come on — be bold, take that shot!
Come on — be bold, take that shot!
Come on — be bold, take that shot!
Come on — be bold, take that shot!
Come on — be bold, take that shot!
Come on — be bold, take that shot!`,

      `You're vibing with their silhouette, no doubt.
You two click — push and pull like magic.
Even your heart’s syncing up to the rhythm.
You’re drawn in, totally hooked.
Last night, they were chillin' in your space.
Now everything smells like "them" — wild, right?
Each day? A brand-new chapter.
You’re head-over-heels for their whole vibe.`,

      `Come on — be bold, take that shot!
Come on — be bold, take that shot!
You’re still thinking about that body.
Come on — be bold, take that shot!
Come on — be bold, take that shot!
Yeah, that shape’s still on your mind.
Come on — be bold, take that shot!
Come on — be bold, take that shot!
You’re caught up in the mystery.
Each day hits different — no two the same.
And you're sold on the shape, no refunds.`,
    ],
  },
  {
    id: "18",
    number: 18,
    date: "2026-05-19",
    title: "Do I Wanna Know?",
    artist: "Arctic Monkeys",
    link: "https://www.youtube.com/embed/bpOSxM0rNPM",
    style: "Conspiracy Theory",
    lyricsOriginal: [
      `Have you got colour in your cheeks?
Do you ever get that fear that you can't shift
The type that sticks around like summat in your teeth?
Are there some aces up your sleeve?
Have you no idea that you're in deep?
I dreamt about you nearly every night this week
How many secrets can you keep?
'Cause there's this tune I found that makes me think of you somehow and I play it on repeat
Until I fall asleep
Spilling drinks on my settee`,

      `(Do I wanna know?)
If this feeling flows both ways?
(Sad to see you go)
Was sort of hoping that you'd stay
(Baby, we both know)
That the nights were mainly made for saying things that you can't say tomorrow day`,

      `Crawling back to you`,

      `Ever thought of calling when you've had a few?
'Cause I always do
Maybe I'm too busy being yours to fall for somebody new
Now I've thought it through`,

      `Crawling back to you`,

      `So have you got the guts?
Been wondering if your heart's still open and if so I wanna know what time it shuts
Simmer down and pucker up
I'm sorry to interrupt. It's just I'm constantly on the cusp of trying to kiss you
I don't know if you feel the same as I do
But we could be together if you wanted to`,

      `(Do I wanna know?)
If this feeling flows both ways?
(Sad to see you go)
Was sort of hoping that you'd stay
(Baby, we both know)
That the nights were mainly made for saying things that you can't say tomorrow day`,

      `Crawling back to you (crawling back to you)`,

      `Ever thought of calling when you've had a few? (you've had a few)
'Cause I always do ('cause I always do)
Maybe I'm too (maybe I'm too busy) busy being yours to fall for somebody new
Now I've thought it through`,

      `Crawling back to you`,

      `(Do I wanna know?)
If this feeling flows both ways?
(Sad to see you go)
Was sort of hoping that you'd stay
(Baby, we both know)
That the nights were mainly made for saying things that you can't say tomorrow day`,

      `(Do I wanna know?)
Too busy being yours to fall
(Sad to see you go)
Ever thought of calling darling?
(Do I wanna know?)
Do you want me crawling back to you?`,
    ],
    lyricsModified: [
      `You ever feel like something’s planted in your head?
Like a coded message you can’t unsee, stuck in your teeth?
You think maybe they’re hiding tricks up their sleeve?
Wake up, you’re deeper in this than you realize.
Been dreaming about the same subject — every night this week.
Coincidence? Doubt it.
How many secrets are they storing?
Found a looped signal — a melody that triggers memories of you.
Been playing it nonstop… ‘til I black out.
Evidence: beverage spillage during playback.`,

      `(Is it mutual infiltration?)
You leaving felt too clean.
Almost like someone didn’t want you to stay.
We both know — those late nights? Prime time for real talk.
Stuff you can’t say when the sun’s up.`,

      `Backtracking again. Classic.`,

      `Ever get the urge to call after a few drinks?
It’s always then — predictable pattern.
Maybe I’m already too deep in this operation to notice new players.
Finally started putting the puzzle together.`,

      `Yup. Returning to point of origin.`,

      `You got the nerve for this?
Is your emotional firewall still down? If yes — I need timestamps.
Calm your frequencies. Prep for contact.
Apologies for the interference — this signal’s hard to suppress.
I’m always on the verge of making a move.
No clue if your reception’s tuned to mine.
But if we synced up? The possibilities…`,

      `(Repeat query: Is this two-way traffic?)
You disappearing wasn’t random.
Kinda hoped you’d ignore the exit protocol.
Let’s face it — those late transmissions?
They carry the real data.`,

      `Return sequence initiated. (Yep, again.)`,

      `Thought about calling after exposure? (You always do.)
That makes two of us.
Maybe I’m too embedded in this mission to recruit someone new.
Assessment updated post-analysis.`,

      `Back at square one.`,

      `(Is this loop mutual?)
Still feeling the disconnect.
Still wondering if you’d break silence.
Still decoding what this all meant during the night ops.`,

      `(Do I even want the truth?)
Already compromised by you.
Did you ever plan to reestablish contact?
Bottom line — am I supposed to keep crawling back into this?`,
    ],
  },
  {
    id: "17",
    number: 17,
    date: "2026-05-18",
    title: "Sucker",
    artist: "Jonas Brothers",
    link: "https://www.youtube.com/embed/CnAmeh0-E-U",
    style: "Vice President's Speech",
    lyricsOriginal: [
      `We go together
Better than birds of a feather, you and me
We change the weather, yeah
I'm feelin' heat in December when you're 'round me`,

      `I've been dancin' on top of cars and stumblin' out of bars
I follow you through the dark, can't get enough
You're the medicine and the pain, the tattoo inside my brain
And, baby, you know it's obvious`,

      `I'm a sucker for you
You say the word and I'll go anywhere blindly
I'm a sucker for you, yeah
Any road you take, you know that you'll find me
I'm a sucker for all the subliminal things
No one knows about you (About you), about you (About you)
And you're makin' the typical me break my typical rules
It's true, I'm a sucker for you, yeah`,

      `Don't complicate it (Yeah)
'Cause I know you and you know everything about me
I can't remember (Yeah) all of the nights
I don't remember when you're 'round me (Oh, yeah, yeah)`,

      `I've been dancin' on top of cars and stumblin' out of bars
I follow you through the dark, can't get enough
You're the medicine and the pain, the tattoo inside my brain
And, baby, you know it's obvious`,

      `I'm a sucker for you
You say the word and I'll go anywhere blindly
I'm a sucker for you, yeah
Any road you take, you know that you'll find me
I'm a sucker for all the subliminal things
No one knows about you (About you), about you (About you)
And you're makin' the typical me break my typical rules
It's true, I'm a sucker for you, yeah (Uh)`,

      `(I'm a sucker for you)
I've been dancin' on top of cars and stumblin' out of bars
I follow you through the dark, can't get enough
You're the medicine and the pain, the tattoo inside my brain
And, baby, you know it's obvious`,

      `I'm a sucker for you, yeah
Say the word and I'll go anywhere blindly
I'm a sucker for you, yeah
Any road you take, you know that you'll find me
I'm a sucker for all the subliminal things
No one knows about you (About you), about you (About you)
And you're makin' the typical me break my typical rules
It's true, I'm a sucker for you (Uh)
I'm a sucker for you`,
    ],
    lyricsModified: [
      `Mr. President, we operate in tandem,
With a synergy stronger than nature’s own design.
Together, we shift the course of events,
Even the seasons bend when you're near — December feels like July.`,

      `Sir, I have navigated chaos — stood atop wreckage, staggered from tumult.
Yet in darkness, I am drawn to your guidance — insatiably.
You are both my cure and my affliction, a constant presence in my thoughts.
Frankly, it's undeniable.`,

      `I am unequivocally devoted to you.
Your directives? I follow without hesitation or question.
Indeed, wherever you lead, I will be in pursuit.
You influence me in ways unknown to others.
You disrupt my patterns, rewrite my rules,
And the truth is clear: I am wholly committed to you.`,

      `Let’s not overcomplicate the matter.
You understand me intimately — as I do you.
The details blur in your presence —
Nights once remembered, now vanish when you're near.`,

      `Again, I’ve found myself immersed in chaos,
Yet I pursue your path, undeterred, drawn to your light.
You're the salve and the sting, etched permanently in my consciousness.
Mr. President, the signs are evident.`,

      `I remain devoted to you.
Speak, and I will respond without delay.
I walk every path you mark, without fail.
You hold a truth no one else perceives.
You compel me to abandon the expected, to step outside the mold.
It is, without doubt, because of you.`,

      `(And yes, I remain devoted.)
Once more, I’ve walked through uncertainty and missteps,
Yet I follow where you go, unsatisfied until I do.
You reside within my mind — an indelible force.
Mr. President, there’s no denying it now.`,

      `You have my full allegiance.
You call, and I arrive, no questions asked.
You lead, and I follow, without pause.
There are details only I know of you,
And because of them, you dismantle my old self and summon the new.
It's a fact: I am entirely yours.
Yes, sir — I'm yours.`,
    ],
  },
  {
    id: "16",
    number: 16,
    date: "2026-05-17",
    title: "Sk8er Boi",
    artist: "Avril Lavigne",
    link: "https://www.youtube.com/embed/TIy3n2b7V9k",
    style: "Biblical",
    lyricsOriginal: [
      `He was a boy.
She was a girl.
Can I make it anymore obvious?
He was a punk.
She did ballet.
What more can I say?
He wanted her.
She'd never tell.
Secretly she wanted him as well.
And all of her friends stuck up their nose.
They had a problem with his baggy clothes.`,

      `He was a skater boy.
She said, "See ya later, boy."
He wasn't good enough for her.
She had a pretty face but her head was up in space.
She needed to come back down to earth.`,

      `Five years from now, she sits at home feeding the baby.
She's all alone.
She turns on TV and guess who she sees?
Skater boy rockin' up MTV.
She calls up her friends.
They already know.
And they've all got tickets to see his show.
She tags along,
Stands in the crowd,
Looks up at the man that she turned down.`,

      `He was a skater boy.
She said, "See ya later, boy."
He wasn't good enough for her.
Now he's a superstar
Slammin' on his guitar
Does your pretty face see what he's worth?`,

      `He was a skater boy.
She said, "See ya later, boy."
He wasn't good enough for her.
Now he's a superstar
Slammin' on his guitar
Does your pretty face see what he's worth?`,

      `Sorry, girl, but you missed out.
Well, tough luck, that boy's mine now.
We are more than just good friends.
This is how the story ends.
Too bad that you couldn't see...
See the man that boy could be.
There is more than meets the eye,
I see the soul that is inside.`,

      `He's just a boy, and I'm just a girl.
Can I make it anymore obvious?
We are in love.
Haven't you heard how we rock each other's world?`,

      `I'm with the skater boy.
I said, "See ya later, boy."
I'll be backstage after the show.
I'll be at the studio singing the song we wrote
About a girl you used to know.`,

      `I'm with the skater boy.
I said, "See ya later, boy."
I'll be backstage after the show.
I'll be at the studio singing the song we wrote
About a girl you used to know.`,
    ],
    lyricsModified: [
      `And lo, there was a lad.
And verily, there was a maiden.
Couldst thou make it more plain?
The lad was of rebellious spirit.
And the maiden did dance with grace.
What further could be spoken?
The lad’s heart longed for her.
Yet she held her tongue.
And behold, in secret, her heart did yearn likewise.
But her companions, haughty in spirit, turned up their noses.
For they were displeased by the raiment he wore, baggy and unrefined.`,

      `The lad was called he who glideth upon the pavement.
And the maiden proclaimed, “Depart from me, thou he who glideth upon the pavement.”
He was deemed unworthy in her eyes.
Her visage was comely, yet her thoughts dwelled in the heavens.
She had need to descend, and return unto the earth.`,

      `And it came to pass, five years hence, the maiden sat within her house, nursing her babe, alone.
She turned on the glowing box of vision, and lo, whom did she behold?
He who glideth upon the pavement, rising in fame upon the scrolls of MTV.
She rang her companions, who knew already.
Yea, they held passes to his gathering.
She journeyed forth, stood amidst the multitude,
And lifted her gaze unto the man she once refused.`,

      `He was he who glideth upon the pavement.
She had said, “Depart from me, thou he who glideth upon the pavement.”
He was not esteemed in her sight.
Now is he a man of renown,
Striking his instrument with fervor.
Doth her fair countenance now perceive his worth?`,

      `He was he who glideth upon the pavement.
She had said, “Depart from me, thou he who glideth upon the pavement.”
He was not esteemed in her sight.
Now is he a man of renown,
Striking his instrument with fervor.
Doth her fair countenance now perceive his worth?`,

      `Hearken, O maiden, thou hast missed thine hour.
For fortune hath turned, and now the lad is mine.
We are joined, not in friendship alone, but in heart.
Thus doth the tale reach its end.
Woe unto thee, who saw not
The man that the boy was destined to become.
For beneath the flesh dwelleth a soul of light, hidden from thine eyes.`,

      `He is but a boy, and I, a maid.
What further proof dost thou seek?
Our hearts are one.
Hast thou not heard the song of our union, which shaketh the earth with joy?`,

      `I dwell now with he who glideth upon the pavement.
Yea, I said unto him, “Depart not from me, he who glideth upon the pavement.”
I shall be behind the veil of the stage, when the playing hath ceased.
And in the house of sound, we shall lift our voices,
To sing of the one whom he once knew.`,

      `I dwell now with he who glideth upon the pavement.
Yea, I said unto him, “Depart not from me, he who glideth upon the pavement.”
I shall be behind the veil of the stage, when the playing hath ceased.
And in the house of sound, we shall lift our voices,
To sing of the one whom he once knew.`,
    ],
  },
  {
    id: "15",
    number: 15,
    date: "2026-05-16",
    title: "Someone Like You",
    artist: "Adele",
    link: "https://www.youtube.com/embed/hLQl3WQQoQ0",
    style: "Private Investigator Notes",
    lyricsOriginal: [
      `I heard that you're settled down
That you found a girl and you're married now.
I heard that your dreams came true.
Guess she gave you things I didn't give to you.`,

      `Old friend, why are you so shy?
Ain't like you to hold back or hide from the light.`,

      `I hate to turn up out of the blue uninvited
But I couldn't stay away, I couldn't fight it.
I had hoped you'd see my face and that you'd be reminded
That for me it isn't over.`,

      `Never mind, I'll find someone like you
I wish nothing but the best for you too
Don't forget me, I beg
I'll remember you said,
"Sometimes it lasts in love but sometimes it hurts instead,
Sometimes it lasts in love but sometimes it hurts instead"`,

      `You know how the time flies
Only yesterday was the time of our lives
We were born and raised
In a summer haze
Bound by the surprise of our glory days`,

      `I hate to turn up out of the blue uninvited
But I couldn't stay away, I couldn't fight it.
I'd hoped you'd see my face and that you'd be reminded
That for me it isn't over.`,

      `Never mind, I'll find someone like you
I wish nothing but the best for you too
Don't forget me, I beg
I'll remember you said,
"Sometimes it lasts in love but sometimes it hurts instead."`,

      `Nothing compares
No worries or cares
Regrets and mistakes
They are memories made.
Who would have known how bittersweet this would taste?`,

      `Never mind, I'll find someone like you
I wish nothing but the best for you
Don't forget me, I beg
I'll remember you said,
"Sometimes it lasts in love but sometimes it hurts instead".`,

      `Never mind, I'll find someone like you
I wish nothing but the best for you too
Don't forget me, I beg
I'll remember you said,
"Sometimes it lasts in love but sometimes it hurts instead,
Sometimes it lasts in love but sometimes it hurts instead."`,
    ],
    lyricsModified: [
      `Received intel: subject has moved on.  
Confirmed: new romantic partner, marital status changed.  
Rumors indicate personal aspirations now fulfilled.  
Suspect's partner provided emotional support previously absent.`,

      `Observation: former associate exhibiting uncharacteristic reticence.  
Behavior inconsistent with known personality — avoiding confrontation, evading contact.`,

      `Incident: unexpected reappearance at known location.  
Motivation unclear — possibly emotional impulse.  
Stated intent: visual presence might trigger recognition, closure sought.  
Conclusion: case unresolved from agent’s perspective.`,

      `Resolution statement: agent will pursue similar profile elsewhere.  
Well wishes extended.  
Direct appeal made to preserve memory.  
Recollection: subject once stated,  
"Sometimes connections endure; other times, they result in emotional distress."`,

      `Reflection: time elapsed rapidly.  
Prior events feel recent — perceived as 'golden period.'  
Location and context: warm season, shared upbringing.  
Bond formed through unexpected shared success.`,

      `Repeat incident: agent arrived unannounced.  
Internal conflict acknowledged; impulse uncontrollable.  
Hope persisted that contact would trigger recognition.  
Personal closure still not achieved.`,

      `Repeat resolution: search for similar candidate ongoing.  
Agent continues to wish subject well.  
Another request: memory retention.  
Recalled statement,  
"Sometimes connections endure; sometimes they cause pain."`,

      `Summary: incomparable experience.  
Minimal concerns during event duration.  
Errors and regrets identified — categorized as formative memories.  
Post-event emotional outcome: unexpectedly complex.`,

      `Resolution reaffirmed: pursuit continues.  
Subject remains in good standing.  
Final plea to be remembered.  
Noted phrase:  
"Sometimes connections endure; sometimes they hurt."`,

      `Final entry: pursuit ongoing.  
Best wishes reiterated.  
Direct emotional appeal logged.  
Statement remains:  
"Sometimes connections endure; sometimes they hurt.  
Sometimes connections endure; sometimes they hurt."`,
    ],
  },
  {
    id: "14",
    number: 14,
    date: "2026-05-15",
    title: "Highway to Hell",
    artist: "AC/DC",
    link: "https://www.youtube.com/embed/l482T0yNkeo",
    style: "Drag Queen Sass",
    lyricsOriginal: [
      `Living easy, lovin' free
Season ticket on a one way ride
Asking nothing, leave me be
Taking everythin' in my stride
Don't need reason, don't need rhyme
Ain't nothing I'd rather do
Goin' down, party time
My friends are gonna be there too, yeah`,

      `I'm on the highway to hell
On the highway to hell
Highway to hell
I'm on the highway to hell`,

      `No stop signs, speed limit
Nobody's gonna slow me down
Like a wheel, gonna spin it
Nobody's gonna mess me around
Hey Satan, payin' my dues
Playing in a rocking band
Hey mama, look at me
I'm on the way to the promised land
Woo!`,

      `I'm on the highway to hell
Highway to hell
I'm on the highway to hell
Highway to hell`,

      `Don't stop me
Heh, heh!`,

      `I'm on the highway to hell
On the highway to hell
Highway to hell
I'm on the highway to hell
(Highway to hell) I'm on the highway to hell
(Highway to hell) Highway to hell
(Highway to hell) Highway to hell
(Highway to hell)`,

      `And I'm going down
All the way
I'm on the highway to hell`,
    ],
    lyricsModified: [
      `Feelin’ fierce, cruisin’ free  
Front row pass on a one-way thrill  
No questions, just let me be  
Struttin’ through it all with grace and skill  
No excuses, no fancy lines  
Got better things than wasting time  
Slidin’ down, it’s showtime, hun  
And baby, all my glam fam's comin' to stun`,

      `I'm rollin' down that glitter lane  
On that glitter lane  
Glitter lane  
I'm rollin' down that glitter lane`,

      `No red lights, full-on blast  
Ain’t nobody gonna dim this flash  
Like a wheel, I twirl and slay  
Ain’t nobody gonna throw shade my way  
Hey drama, paid my dues  
Still servin’ looks with my sparkly crew  
Hey diva, watch me shine  
I’m risin’ up to that crown so fine  
Woo!`,

      `I'm rollin' down that glitter lane  
Glitter lane  
I'm rollin' down that glitter lane  
Glitter lane`,

      `Try and stop me  
Heh, heh!`,

      `I'm rollin' down that glitter lane  
On that glitter lane  
Glitter lane  
I'm rollin' down that glitter lane  
(Glitter lane) I'm rollin' down that glitter lane  
(Glitter lane) Glitter lane  
(Glitter lane) Glitter lane  
(Glitter lane)`,

      `And I’m glidin’ low  
All the way  
I'm rollin' down that glitter lane`,
    ],
  },
  {
    id: "13",
    number: 13,
    date: "2026-05-14",
    title: "Blinding Lights",
    artist: "The Weeknd",
    link: "https://www.youtube.com/embed/4NRXx6U8ABQ",
    style: "Help Center Script",
    lyricsOriginal: [
      `I've been tryna call
I've been on my own for long enough
Maybe you can show me how to love, maybe
I'm going through withdrawals
You don't even have to do too much
You can turn me on with just a touch, baby`,

      `I look around and
Sin City's cold and empty (Oh)
No one's around to judge me (Oh)
I can't see clearly when you're gone`,

      `I said, ooh, I'm blinded by the lights
No, I can't sleep until I feel your touch
I said, ooh, I'm drowning in the night
Oh, when I'm like this, you're the one I trust
Hey, hey, hey`,

      `I'm running out of time
'Cause I can see the sun light up the sky
So I hit the road in overdrive, baby, oh`,

      `The city's cold and empty (Oh)
No one's around to judge me (Oh)
I can't see clearly when you're gone`,

      `I said, ooh, I'm blinded by the lights
No, I can't sleep until I feel your touch
I said, ooh, I'm drowning in the night
Oh, when I'm like this, you're the one I trust`,

      `I'm just calling back to let you know (Back to let you know)
I could never say it on the phone (Say it on the phone)
Will never let you go this time (Ooh)`,

      `I said, ooh, I'm blinded by the lights
No, I can't sleep until I feel your touch
Hey, hey, hey
Hey, hey, hey`,

      `I said, ooh, I'm blinded by the lights
No, I can't sleep until I feel your touch`,
    ],
    lyricsModified: [
      `Well now, I've been tryin' to reach ya,
Been ridin' solo through these lonesome nights.
Maybe you could show a fella how to love again, just maybe.
Feelin’ mighty restless out here on my own,
But darlin’, you don’t gotta do much—
Just a gentle touch from you fires me right up.`,

      `Took a look ‘round, and lemme tell ya—
This ol’ Sin City’s colder than a snake’s belly in a wagon rut (yep).
Ain’t a soul around to lay judgment (thank the stars).
But it sure gets hard to see straight when you’re gone, sugar.`,

      `I said, ooh, I’m blinded by them neon lights,
Can’t close my eyes ‘til I feel your sweet touch.
I said, ooh, I’m sinkin’ deep into this starless night,
And when I’m down like this, you’re the only one I’d bet my boots on.
Yeehaw.`,

      `Time’s tickin’ faster than a jackrabbit on a date,
‘Cause I see the sunrise paintin’ the sky gold.
So I hit the dusty trail, ridin’ hard, no lookin’ back, darlin’—no lookin’ back.`,

      `Ain’t no warmth left in this here town (cold as a prairie wind),
And no one left to care what I do (not a soul).
My world don’t make much sense without you around, sugar.`,

      `Like I said before, ooh, them lights got me blind as a bat in daylight,
Can’t catch no wink o’ sleep ‘til I feel your hand in mine.
Ooh, I’m drownin’ in the dark out here,
But when I’m feelin’ this lost, you’re my true North Star.`,

      `Just callin’ back to give you the skinny (had to let you know),
Ain’t the type to speak soft on the line (nah),
But this time, I ain’t lettin’ you go, no ma’am.`,

      `I said, ooh, them lights still blindin’ me somethin’ fierce,
Ain’t gonna sleep ‘til I’ve got you by my side.
Hey, hey, hey...
Yup, hey, hey, hey...`,

      `I said, ooh, I’m still lost in that light show,
And darlin’, sleep won’t find me ‘til your touch does.`,
    ],
  },
  {
    id: "12",
    number: 12,
    date: "2026-05-13",
    title: "Somebody That I Used to Know",
    artist: "Gotye",
    link: "https://www.youtube.com/embed/8UVNT4wvIGY",
    style: "Self Help Book",
    lyricsOriginal: [
      `Now and then I think of when we were together
Like when you said you felt so happy you could die
Told myself that you were right for me
But felt so lonely in your company
But that was love and it's an ache I still remember`,

      `You can get addicted to a certain kind of sadness
Like resignation to the end, always the end
So when we found that we could not make sense
Well you said that we would still be friends
But I'll admit that I was glad that it was over`,

      `But you didn't have to cut me off
Make out like it never happened and that we were nothing
And I don't even need your love
But you treat me like a stranger and that feels so rough
No you didn't have to stoop so low
Have your friends collect your records and then change your number
I guess that I don't need that though
Now you're just somebody that I used to know`,

      `Now you're just somebody that I used to know
Now you're just somebody that I used to know`,

      `Now and then I think of all the times you screwed me over
But had me believing it was always something that I'd done
But I don't wanna live that way
Reading into every word you say
You said that you could let it go
And I wouldn't catch you hung up on somebody that you used to know`,

      `But you didn't have to cut me off
Make out like it never happened and that we were nothing
And I don't even need your love
But you treat me like a stranger and that feels so rough
No you didn't have to stoop so low
Have your friends collect your records and then change your number
I guess that I don't need that though
Now you're just somebody that I used to know`,

      `Somebody
(I used to know)
Somebody
(Now you're just somebody that I used to know)`,

      `Somebody
(I used to know)
Somebody
(Now you're just somebody that I used to know)`,

      `(I used to know)
(That I used to know)
(I used to know)
Somebody`,
    ],
    lyricsModified: [
      `Occasionally, we reflect on the relationships that once brought us joy and connection
We recall moments where we felt so alive, so fulfilled, that it seemed like everything was perfect
But in hindsight, it’s clear that the emotional connection didn’t fully meet our needs
We were made to believe we were aligned, but in reality, we were left feeling isolated in the very company we thought would bring us comfort
Yet, we learned, and the pain still serves as a reminder of what it means to truly grow`,

      `We often find ourselves attached to the familiar feeling of sadness, as though it has become a part of us
We resign ourselves to the belief that it’s just the way things are—always an ending, never a beginning
But as we reach the point of realization, we understand that sometimes endings offer us clarity
We tell ourselves we will remain friends, but deep down, we recognize the freedom that comes when we let go`,

      `There is no need to carry the weight of unnecessary emotional baggage
You didn't need to dismiss me or pretend that our experiences never mattered
Our connection was important, but I no longer need your validation
I refuse to allow your actions to dictate how I feel
You treated me as though I were irrelevant, a stranger—and this behavior only reinforces the necessity of moving on
You've chosen to remove yourself, and that's okay; now, you are simply a chapter I once lived`,

      `And now, you exist as a distant memory—someone I once knew`,

      `From time to time, I reflect on the way past betrayals were framed as my fault
I accepted the blame, not realizing that it wasn't entirely mine to carry
I don’t want to live in a state of constant self-doubt, analyzing every word and action, trying to piece together what went wrong
You promised me closure, but the fact that you're still hanging onto what we had shows that there’s still work left to do on both sides`,

      `It's important to remember that there is no need to allow someone to take away your peace of mind by dismissing you entirely
You don’t have to let their actions define your self-worth
Even when it feels like they’ve erased your existence, it's crucial to remind yourself that you can stand on your own
The changes they made are just signs of their own unresolved issues, not a reflection of who you are
And now, you've become a past version of someone I once knew`,

      `Someone  
(once held space in my life)  
Someone  
(who now exists only in memory—no longer part of who I am becoming)`,

      `Someone  
(once held space in my life)  
Somebody  
(who now exists only in memory—no longer part of who I am becoming)`,

      `(once held space in my life)  
(who once held space in my life)  
(once held space in my life)  
Someone`,
    ],
  },
  {
    id: "11",
    number: 11,
    date: "2026-05-12",
    title: "Lose Yourself",
    artist: "Eminem",
    link: "https://www.youtube.com/embed/xFYQQPAOz7Y",
    style: "Scientific Jargon",
    lyricsOriginal: [
      `Look, if you had one shot, or one opportunity
To seize everything you ever wanted, in one moment
Would you capture it, or just let it slip?`,

      `Yo! His palms are sweaty, knees weak, arms are heavy
There's vomit on his sweater already: Mom's spaghetti
He's nervous, but on the surface he looks calm and ready
To drop bombs, but he keeps on forgetting
What he wrote down, the whole crowd goes so loud
He opens his mouth, but the words won't come out
He's choking, how? Everybody's joking now
The clock's run out, time's up, over, blaow!
Snap back to reality, ope there goes gravity, ope
There goes Rabbit, he choked, he's so mad but he won't
Give up that easy, no, he won't have it, he knows
His whole back's to these ropes, it don't matter, he's dope
He knows that but he's broke, he's so stagnant, he knows
When he goes back to this mobile home, that's when it's
Back to the lab again yo, this whole rhapsody
Better go capture this moment and hope it don't pass him, and`,

      `You better lose yourself in the music
The moment, you own it, you better never let it go
You only get one shot, do not miss your chance to blow
This opportunity comes once in a lifetime, yo
You better lose yourself in the music
The moment, you own it, you better never let it go
You only get one shot, do not miss your chance to blow
This opportunity comes once in a lifetime, yo
You better…`,

      `His soul's escaping through this hole that is gaping
This world is mine for the taking, make me king
As we move toward a New World Order
A normal life is boring; but superstardom's
Close to post-mortem, it only grows harder
Homie grows hotter, he blows, it's all over
These hoes is all on him, coast-to-coast shows
He's known as the Globetrotter, lonely roads
God only knows, he's grown farther from home, he's no father
He goes home and barely knows his own daughter
But hold your nose, 'cause here goes the cold water
These hoes don't want him no mo', he's cold product
They moved on to the next schmoe who flows
He nose-dove and sold nada, and so the soap opera
Is told, it unfolds, I suppose it's old, partner
But the beat goes on: da da dum da dum da da da da`,

      `You better lose yourself in the music
The moment, you own it, you better never let it go
You only get one shot, do not miss your chance to blow
This opportunity comes once in a lifetime, yo
You better lose yourself in the music
The moment, you own it, you better never let it go
You only get one shot, do not miss your chance to blow
This opportunity comes once in a lifetime, yo
You better…`,

      `No more games, I'ma change what you call rage
Tear this motherfuckin' roof off like two dogs caged
I was playin' in the beginning, the mood all changed
I've been chewed up and spit out and booed off stage
But I kept rhymin' and stepped right in the next cypher
Best believe somebody's payin' the Pied Piper
All the pain inside amplified by the
Fact that I can't get by with my 9-to-5
And I can't provide the right type of life for my family
'Cause man, these goddamn food stamps don't buy diapers
And there's no movie, there's no Mekhi Phifer, this is my life
And these times are so hard, and it's gettin' even harder
Tryna feed and water my seed, plus teeter-totter
Caught up between bein' a father and a prima donna
Baby mama drama, screamin' on her, too much for me to wanna
Stay in one spot, another day of monotony's
Gotten me to the point I'm like a snail, I've got
To formulate a plot or end up in jail or shot
Success is my only motherfuckin' option, failure's not
Mom, I love you, but this trailer's got
To go; I cannot grow old in Salem's Lot
So here I go, it's my shot: feet, fail me not
This may be the only opportunity that I got`,

      `You better lose yourself in the music
The moment, you own it, you better never let it go (go)
You only get one shot, do not miss your chance to blow
This opportunity comes once in a lifetime, yo
You better lose yourself in the music
The moment, you own it, you better never let it go (go)
You only get one shot, do not miss your chance to blow
This opportunity comes once in a lifetime, yo
You better…`,

      `You can do anything you set your mind to, man`,
    ],
    lyricsModified: [
      `Observe: a singular temporal junction presents itself—
Wherein the subject may acquire all desired outcomes.
Query: does the subject act, or yield to entropy?`,

      `Physiological indicators spike—palmar hyperhidrosis, quadriceps instability, upper limb fatigue.
Gastrointestinal expulsion noted—maternal nutrient solution compromised.
Autonomic arousal evident, yet subject maintains superficial composure.
Prepared to execute kinetic interventions, but episodic memory retrieval fails.
Auditory input from surrounding observers reaches critical decibel levels.
Subject initiates speech protocol, but linguistic pathways fail.
Neurological freeze. Cortical malfunction.
Chronometric limit reached. Task termination.
System reboots—gravity reasserts itself.
Subject fails, experiences acute frustration, yet behavioral persistence remains.
Homeostasis disrupted. Economic resources low. Momentum minimal.
Subject regresses to mobile habitation, initiating cognitive re-evaluation.
Experimental iteration re-engaged—current moment deemed of paramount importance.`,

      `Subject must engage in immersive auditory flow state.
Cognitive ownership of present temporal window is critical—do not relinquish.
Singular opportunity for high-impact output must not be neglected.
Such events are low-frequency on the probability curve.
Re-engage auditory immersion.
Retain cognitive dominance of the active timeline.
Statistical opportunity ≈ once per lifetime.
Recalibrate and commit.`,

      `Subject experiences psycho-emotional discharge via cranial aperture.
Environmental system perceived as exploitable—subject assumes dominant agency.
Macro-sociopolitical shift underway (cf. New World Order).
Standard lifestyle parameters rendered inadequate—stimulus threshold too low.
Fame trajectory increases logarithmically.
Subject reaches thermal and social saturation.
Reproductive-oriented individuals demonstrate attraction across geographic nodes.
However, familial relationships suffer systemic degradation.
Olfactory receptor engagement advised—emotional coolant deployed.
Public interest declines; novelty decays exponentially.
Replacement agents inserted into narrative.
Subject's trajectory falters—data output nullifies.
Socio-emotional narrative continues—loop resumes.
Auditory sequence persists: da-da-dum.`,

      `Reiteration: optimize neural entrainment to music-induced cognitive flow.
Temporal possession imperative—retain control.
Missed opportunity yields irreversible loss.
Event frequency statistically negligible.
Engage. Synchronize. Dominate.`,

      `Simulation terminated—parameters shifting.
Behavioral protocol updated: redefine frustration management algorithm.
Symbolic structural detonation mimicked (cf. "roof off").
Initial engagement was exploratory—affect now destabilized.
Subject experienced systemic rejection and memetic suppression.
Continued lexicon deployment into novel discursive units.
Probabilistic compensation assumed (cf. Pied Piper model).
Internalized psychological tension escalated by socioeconomic deprivation.
Caregiver role compromised by insufficient fiscal resources.
Government-issued sustenance inadequate for offspring maintenance.
Narrative authenticity emphasized—cinematic parallels disavowed.
Environmental conditions increasingly adverse.
Parental responsibilities vs. personal identity conflict arises.
Interpersonal instability causes neurocognitive overload.
Geospatial relocation imminent—avoid existential plateau.
Execute high-stakes opportunity engagement—motor coordination essential.
Potentially final strategic window.`,

      `One final reminder:
Engage neuro-muscular synchronization with auditory stimulus.
Temporal ownership remains non-negotiable.
Probabilistic model allows only one iteration.
This is the inflection point.
Engage.`,

      `Conclusion: neuroplasticity enables realization of statistically improbable goals.`,
    ],
  },
  {
    id: "10",
    number: 10,
    date: "2026-05-11",
    title: "Eye of the Tiger",
    artist: "Survivor",
    link: "https://www.youtube.com/embed/btPJPFnesV4",
    style: "Corporate Speech",
    lyricsOriginal: [
      `Rising up, back on the street
Did my time, took my chances
Went the distance, now I'm back on my feet
Just a man and his will to survive`,

      `So many times it happens too fast
You trade your passion for glory
Don't lose your grip on the dreams of the past
You must fight just to keep them alive`,

      `It's the eye of the tiger
It's the thrill of the fight
Rising up to the challenge of our rival
And the last known survivor
Stalks his prey in the night
And he's watching us all with the eye of the tiger`,

      `Face to face, out in the heat
Hanging tough, staying hungry
They stack the odds still we take to the street
For the kill with the skill to survive`,

      `It's the eye of the tiger
It's the thrill of the fight
Rising up to the challenge of our rival
And the last known survivor
Stalks his prey in the night
And he's watching us all with the eye of the tiger`,

      `Rising up, straight to the top
Had the guts, got the glory
Went the distance, now I'm not gonna stop
Just a man and his will to survive`,

      `It's the eye of the tiger
It's the thrill of the fight
Rising up to the challenge of our rival
And the last known survivor
Stalks his prey in the night
And he's watching us all with the eye of the tiger`,

      `The eye of the tiger
The eye of the tiger
The eye of the tiger
The eye of the tiger`,
    ],
    lyricsModified: [
      `Reengaging, returning to the market
Completed my tasks, seized the opportunities
Achieved key milestones, now I’m back on track
Just an individual and his determination to succeed`,

      `There are moments when things accelerate quickly
You exchange your passion for success
Do not lose sight of the long-term goals
You must maintain focus to keep them in play`,

      `It’s the drive of the achiever
It’s the excitement of overcoming obstacles
Rising to meet the challenge of our competitors
And the final remaining player
Targets their opportunity in the shadows
And they are monitoring us all with the drive of the achiever`,

      `Head-to-head, in the competitive arena
Remaining resilient, staying motivated
The odds are stacked, yet we continue to push forward
To execute with the expertise to succeed`,

      `It’s the drive of the achiever
It’s the excitement of overcoming obstacles
Rising to meet the challenge of our competitors
And the final remaining player
Targets their opportunity in the shadows
And they are monitoring us all with the drive of the achiever`,

      `Reengaging, climbing to the peak
Demonstrated courage, earned recognition
Achieved key milestones, now I will not stop
Just an individual and his determination to succeed`,

      `It’s the drive of the achiever
It’s the excitement of overcoming obstacles
Rising to meet the challenge of our competitors
And the final remaining player
Targets their opportunity in the shadows
And they are monitoring us all with the drive of the achiever`,

      `The drive of the achiever
The drive of the achiever
The drive of the achiever
The drive of the achiever`,
    ],
  },
  {
    id: "9",
    number: 9,
    date: "2026-05-10",
    title: "Zombie",
    artist: "The Cranberries",
    link: "https://www.youtube.com/embed/6Ejga4kJUts",
    style: "Caveman Talk",
    lyricsOriginal: [
      `Another head hangs lowly
Child is slowly taken
And the violence caused such silence
Who are we mistaken`,

      `But you see it's not me
It's not my family
In your head, in your head
They are fighting
With their tanks and their bombs
And their bombs and their guns
In your head, in your head
They are cryin'`,

      `In your head, in your head
Zombie, zombie, zombie, hey, hey
What's in your head, in your head
Zombie, zombie, zombie, hey, hey, hey, oh`,

      `Dou, dou, dou, dou
Dou, dou, dou, dou
Dou, dou, dou, dou
Dou, dou, dou, dou`,

      `Another mother's breakin'
Heart is taking over
When the violence causes silence
We must be mistaken`,

      `It's the same old theme
Since nineteen-sixteen
In your head, in your head
They're still fightin'
With their tanks and their bombs
And their bombs and their guns
In your head, in your head
They are dyin'`,

      `In your head, in your head
Zombie, zombie, zombie, hey, hey
What's in your head, in your head
Zombie, zombie, zombie, hey, hey, hey
Oh, oh, oh, oh, oh, oh, oh
Hey, oh, ya, ya-a`,
    ],
    lyricsModified: [
      `Other head hang low
Child go slow, taken away
Big fight make quiet
Who we fool?`,

      `But you see, not me
Not my tribe
In your head, in your head
Fight, fight, fight
With big rocks and sticks
And big sticks and sharp rocks
In your head, in your head
They cry, cry, cry`,

      `In your head, in your head
Beast, beast, beast, hey, hey
What in your head, in your head
Beast, beast, beast, hey, hey, hey, oh`,

      `Dou, dou, dou, dou
Dou, dou, dou, dou
Dou, dou, dou, dou
Dou, dou, dou, dou`,

      `Other mother sad
Heart hurt, takes over
Big fight make quiet
We must be wrong`,

      `Same old fight
Since many moons ago
In your head, in your head
They fight, fight, fight
With big rocks and sticks
And big sticks and sharp rocks
In your head, in your head
They fall, fall, fall`,

      `In your head, in your head
Beast, beast, beast, hey, hey
What in your head, in your head
Beast, beast, beast, hey, hey, hey
Oh, oh, oh, oh, oh, oh, oh
Hey, oh, ya, ya-a`,
    ],
  },
  {
    id: "8",
    number: 8,
    date: "2026-05-09",
    title: "All Star",
    artist: "Smash Mouth",
    link: "https://www.youtube.com/embed/L_jWHffIx5E",
    style: "Star Wars",
    lyricsOriginal: [
      `Somebody once told me the world is gonna roll me
I ain't the sharpest tool in the shed
She was looking kind of dumb with her finger and her thumb
In the shape of an "L" on her forehead`,

      `Well, the years start coming and they don't stop coming
Fed to the rules and I hit the ground running
Didn't make sense not to live for fun
Your brain gets smart but your head gets dumb`,

      `So much to do, so much to see
So what's wrong with taking the back streets?
You'll never know if you don't go (GO!)
You'll never shine if you don't glow`,

      `Hey, now, you're an all-star, get your game on, go play
Hey, now, you're a rock star, get the show on, get paid
And all that glitters is gold
Only shooting stars break the mold`,

      `It's a cool place and they say it gets colder
You're bundled up now wait 'til you get older
But the meteor man beg to differ
Judging by the hole in the satellite picture`,

      `The ice we skate is getting pretty thin
The water's getting warm so you might as well swim
My world's on fire. How about yours?
That's the way I like it and I'll never get bored`,

      `Hey, now, you're an all-star, get your game on, go play
Hey, now, you're a rock star, get the show on, get paid
And all that glitters is gold
Only shooting stars break the mold`,

      `Hey, now, you're an all-star, get your game on, go play
Hey, now, you're a rock star, get the show on, get paid
And all that glitters is gold
Only shooting stars`,

      `Somebody once asked could I spare some change for gas
I need to get myself away from this place
I said yep, what a concept
I could use a little fuel myself
And we could all use a little change`,

      `Well, the years start coming and they don't stop coming
Fed to the rules and I hit the ground running
Didn't make sense not to live for fun
Your brain gets smart but your head gets dumb`,

      `So much to do, so much to see
So what's wrong with taking the back streets?
You'll never know if you don't go
You'll never shine if you don't glow`,

      `Hey, now, you're an all-star, get your game on, go play
Hey, now, you're a rock star, get the show on, get paid
And all that glitters is gold
Only shooting stars break the mold`,

      `And all that glitters is gold
Only shooting stars break the mold`,
    ],
    lyricsModified: [
      `A wise Jedi once spoke, the galaxy will guide me,
I’m no Master, I’m still learning the ways of the Force
She stood with a blaster, a smirk on her face,
Her hand marked her brow as the rebels’ fate was set`,

      `The years of the Empire come, and they won’t cease,
Bound by the Code, I draw my saber and fight
The galaxy’s chaos does not prevent the thrill
The Force sharpens the mind, but war dulls the soul`,

      `So much to see in this vast, endless space
What harm is there in flying the hidden routes?
You’ll never know the path if you don't take it (TAKE IT!)
You’ll never rise if you don’t let the Force flow`,

      `Now, Jedi, you’re a hero, take your lightsaber and fight
Now, smuggler, you’re a legend, take the bounty and win
All that glows is stardust
Only the brave ever break the Empire’s grip`,

      `The galaxy’s cold, and the dark side’s near
Strap in now, young one, the danger grows clear
But the droid says differently
Look at the star map, there’s hope to be found`,

      `The ice beneath us cracks with every step
The darkness encroaches, but we must keep moving
My heart’s aflame. What of yours?
I embrace it fully, it will never fade`,

      `Now, Jedi, you’re a hero, take your lightsaber and fight
Now, smuggler, you’re a legend, take the bounty and win
All that glows is stardust
Only the brave ever break the Empire’s grip`,

      `Now, Jedi, you’re a hero, take your lightsaber and fight
Now, smuggler, you’re a legend, take the bounty and win
All that glows is stardust
Only the brave ever shatter the mold`,

      `A traveler once asked, could I spare fuel for the ship
I must flee from the Empire’s reach
I said yes, what a mission
I need fuel for my cause, myself
And we all crave a little freedom`,

      `The years of the Empire come, and they won’t cease,
Bound by the Code, I draw my saber and fight
The galaxy’s chaos does not prevent the thrill
The Force sharpens the mind, but war dulls the soul`,

      `So much to see in this vast, endless space
What harm is there in flying the hidden routes?
You’ll never know the path if you don’t take it
You’ll never rise if you don’t let the Force flow`,

      `Now, Jedi, you’re a hero, take your lightsaber and fight
Now, smuggler, you’re a legend, take the bounty and win
All that glows is stardust
Only the brave ever break the Empire’s grip`,

      `All that glows is stardust
Only the brave ever shatter the mold`,
    ],
  },
  {
    id: "7",
    number: 7,
    date: "2026-05-08",
    title: "Toxic",
    artist: "Britney Spears",
    link: "https://www.youtube.com/embed/LOZuxwVk7TU",
    style: "Tolkien",
    lyricsOriginal: [
      `Baby, can't you see I'm calling?
A guy like you should wear a warning
It's dangerous, I'm falling
There's no escape, I can't wait
I need a hit, baby, give me it
You're dangerous, I'm loving it`,

      `Too high, can't come down
Losing my head, spinning 'round and 'round
Do you feel me now?`,

      `With a taste of your lips, I'm on a ride
You're toxic, I'm slipping under
With a taste of a poison paradise
I'm addicted to you
Don't you know that you're toxic?
And I love what you do
Don't you know that you're toxic?`,

      `It's getting late to give you up
I took a sip from my devil's cup
Slowly, it's taking over me`,

      `Too high, can't come down
It's in the air and it's all around
Can you feel me now?`,

      `With a taste of your lips, I'm on a ride
You're toxic, I'm slipping under
With a taste of a poison paradise
I'm addicted to you
Don't you know that you're toxic?
And I love what you do
Don't you know that you're toxic?
Don't you know that you're toxic?`,

      `With a taste of your lips, I'm on a ride
You're toxic, I'm slipping under
With a taste of a poison paradise
I'm addicted to you
Don't you know that you're toxic?
With a taste of your lips, I'm on a ride
You're toxic, I'm slipping under (Toxic)
With a taste of a poison paradise
I'm addicted to you
Don't you know that you're toxic?`,

      `Intoxicate me now with your loving now
I think I'm ready now (I think I'm ready now)
Intoxicate me now with your loving now
I think I'm ready now`,
    ],
    lyricsModified: [
      `Fair maiden, dost thou not hear my cry?
A knight of thine own stature should bear a sign
For perilous is this path, and I am fallen,
No escape awaits, my heart in chains does dwell
Grant me that which I seek, my love, I beg
For thou art the peril I long to cherish`,

      `Lo! I rise upon wings, yet cannot descend
My mind doth whirl, in circles it spins
Dost thou feel my soul now, as I do thine?`,

      `Upon the taste of thy lips, I ride the storm
Thy poison, like the deepest, darkest spell,
A paradise of shadows, I slip below,
To thee I am bound, my heart enslaved
Knowest thou not, thy touch is venom sweet?
I cherish the harm thou bringest unto me`,

      `The hour grows dim to turn from thee
From the goblet of the dark lord I drank,
Slowly, it takes hold of me`,

      `Lo! I rise upon wings, yet cannot descend
The winds of fate blow fierce, all around
Dost thou feel me, as I feel thee now?`,

      `Upon the taste of thy lips, I ride the storm
Thy poison, like the deepest, darkest spell,
A paradise of shadows, I slip below,
To thee I am bound, my heart enslaved
Knowest thou not, thy touch is venom sweet?
I cherish the harm thou bringest unto me`,

      `Upon the taste of thy lips, I ride the storm
Thy poison, like the deepest, darkest spell,
A paradise of shadows, I slip below,
To thee I am bound, my heart enslaved
Knowest thou not, thy touch is venom sweet?
I cherish the harm thou bringest unto me`,

      `Entwine me in thy love, intoxicating grace,
I stand ready, my soul is thine to take
I am ready now, take me as thine own`,
    ],
  },
  {
    id: "6",
    number: 6,
    date: "2026-05-07",
    title: "Wonderwall",
    artist: "Oasis",
    link: "https://www.youtube.com/embed/bx1Bh8ZvH84",
    style: "Shakespearean Tragedy",
    lyricsOriginal: [
      `Today is gonna be the day
That they're gonna throw it back to you
By now you should've somehow
Realized what you gotta do
I don't believe that anybody
Feels the way I do about you now`,

      `Backbeat, the word is on the street
That the fire in your heart is out
I'm sure you've heard it all before
But you never really had a doubt
I don't believe that anybody feels
The way I do about you now`,

      `And all the roads we have to walk are winding
And all the lights that lead us there are blinding
There are many things that I would
Like to say to you
But I don't know how`,

      `Because maybe
You're gonna be the one that saves me
And after all
You're my wonderwall`,

      `Today was gonna be the day
But they'll never throw it back to you
By now you should've somehow
Realized what you're not to do
I don't believe that anybody
Feels the way I do
About you now`,

      `And all the roads that lead you there were winding
And all the lights that light the way are blinding
There are many things that I would like to say to you
But I don't know how`,

      `I said maybe
You're gonna be the one that saves me
And after all
You're my wonderwall`,

      `I said maybe (I said maybe)
You're gonna be the one that saves me
And after all
You're my wonderwall`,

      `I said maybe (I said maybe)
You're gonna be the one that saves me (saves me)
You're gonna be the one that saves me (saves me)
You're gonna be the one that saves me (saves me)`,
    ],
    lyricsModified: [
      `Lo! This day shall be the one
When they shall cast it back unto thee
By this hour, thou shouldst have surely
Perceived the task thou art bound to do
I doubt not that no soul
Doth feel as I do, in earnest regard for thee`,

      `Hark! The town doth whisper loud upon the street
That the fire within thy heart hath waned
Thou hast likely heard such tales afore
Yet thou hast ne’er truly doubted
I doubt not that no soul doth feel
As I do, with fervent passion for thee`,

      `Alas! The roads we must tread are fraught with turns
And the lights that guide us seem blinding, harsh
Many things do I long to speak unto thee
Yet I am lost in my words, unsure how`,

      `Perchance
Thou art the one who shall deliver me from despair
And when the storm hath passed
Thou art mine own beacon of hope`,

      `This day was to be the one
Yet they shall never cast it back unto thee
By this hour, thou shouldst have surely
Realized what thou shouldst not do
I doubt not that no soul doth feel
As I do
With undying devotion to thee`,

      `And the paths that lead thee to thy fate are winding
And the lights that illuminate thy way doth blind thee
Many things I yearn to speak to thee
Yet I am without the means to utter`,

      `I say, perchance
Thou art the one who shall redeem my soul
And when all is done
Thou art mine own salvation`,

      `I say, perchance (I say, perchance)
Thou art the one who shall redeem my soul
And when all is done
Thou art mine own salvation`,

      `I say, perchance (I say, perchance)
Thou art the one who doth save me (save me)
Thou art the one who doth save me (save me)
Thou art the one who doth save me (save me)`,
    ],
  },
  {
    id: "5",
    number: 5,
    date: "2026-05-06",
    title: "Bad Guy",
    artist: "Billie Eilish",
    link: "https://www.youtube.com/embed/DyDfgMOUjCI",
    style: "Gen Z Slang",
    lyricsOriginal: [
      `White shirt now red, my bloody nose
Sleeping, you're on your tippy toes
Creeping around like no one knows
Think you're so criminal`,

      `Bruises on both my knees for you
Don't say thank you or please, I do
What I want when I'm wanting to
My soul? So cynical`,

      `So you're a tough guy
Like-it-really-rough guy
Just-can't-get-enough guy
Chest-always-so-puffed guy
I'm that bad type
Make-your-mama-sad type
Make-your-girlfriend-mad type
Might-seduce-your-dad type
I'm the bad guy, duh`,

      `I'm the bad guy`,

      `I like it when you take control
Even if you know that you don't
Own me, I'll let you play the role
I'll be your animal`,

      `My mommy likes to sing along
With me but she won't sing this song
If she reads all the lyrics
She'll pity the men I know`,

      `So you're a tough guy
Like-it-really-rough guy
Just-can't-get-enough guy
Chest-always-so-puffed guy
I'm that bad type
Make-your-mama-sad type
Make-your-girlfriend-mad type
Might-seduce-your-dad type
I'm the bad guy, duh`,

      `I'm the bad guy, duh`,

      `I'm only good at being bad
Bad`,

      `I like when you get mad
I guess I'm pretty glad
That you're alone
You said she's scared of me?
I mean
I don't see what she sees
But maybe it's 'cause I'm wearing your cologne`,

      `I'm a bad guy
I'm, I'm a bad guy
Bad guy, bad guy
I'm a bad guy`,
    ],
    lyricsModified: [
      `White tee now red, 'cause my nose is a crime scene,
You sleepin', but you creeping, always on your tiptoes.
Lurking 'round like no one knows, thinking you're a criminal,
Bruh, you really think you're slick? LMAO, ok, chill.`,

      `Bruises on my knees? Yeah, for you, I'm down.
No “thank you” or “please,” I don’t even need that.
I do what I want, whenever I feel like it,
Soul’s pretty messed up, real cynical with it.`,

      `Oh, you a tough guy?
Big talk, rough vibes, can’t get enough, guy.
Puffed chest, flexin' hard, like a gym rat guy,
I'm the bad type,
Make-your-mom-cry type,
Make-your-girlfriend-mad type,
Might-steal-your-dad type.
I'm the certified villain, duh.`,

      `Yeah, I'm that certified villain.`,

      `I like when you act in charge,
Even though we both know you don't.
You don’t own me, but go ahead, play your role,
I’ll be your animal, if that's what you want.`,

      `My mom vibes with me, sings to my tracks,
But this one? Nah, she won't sing along to that.
She reads the lyrics, and I know she’s shook,
Feeling bad for these dudes, that’s all it took.`,

      `Oh, you a tough guy?
Big talk, rough vibes, can’t get enough, guy.
Puffed chest, flexin' hard, like a gym rat guy,
I'm the bad type,
Make-your-mom-cry type,
Make-your-girlfriend-mad type,
Might-steal-your-dad type.
I'm the certified villain, duh.`,

      `Yeah, I’m still the certified villain.`,

      `I'm good at being bad, that's my whole vibe.
Bad? Yep, it's what I do best, no cap.`,

      `Love when you get mad, it’s kinda fun.
Guess I'm low-key happy that you're solo.
She said she's scared of me? LMAO, why tho?
I don’t see it, but maybe it’s 'cause I rock your cologne.`,

      `Yeah, I’m the certified villain.
You know it, I know it, we all know it.
Certified villain, menace, chaos is my game.
I'm the certified villain.`,
    ],
  },
  {
    id: "4",
    number: 4,
    date: "2026-05-05",
    title: "Smooth Criminal",
    artist: "Michael Jackson",
    link: "https://www.youtube.com/embed/h_D3VFfhvs4",
    style: "Jane Austen",
    lyricsOriginal: [
      `As he came into the window
It was a sound of a crescendo
He came into her apartment
He left the bloodstains on the carpet
She ran underneath the table
He could see she was unable
So she ran into the bedroom
She was struck down, it was her doom`,

      `Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?`,

      `Annie, are you okay? Will you tell us that you're okay?
There's a sound at the window that he struck you, a crescendo, Annie
He came into your apartment, and left the bloodstains on the carpet
Then you ran into the bedroom, you were struck down, it was your doom`,

      `Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
You've been hit by, you've been hit by, a smooth criminal
Ow!`,

      `So they came in to the outway
It was Sunday, what a black day
Mouth-to-mouth resuscitation
Sounding heartbeats, intimidations`,

      `Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?`,

      `Annie, are you okay? Will you tell us that you're okay?
There's a sound at the window that he struck you, a crescendo, Annie
He came into your apartment, and left the bloodstains on the carpet
And then you ran into the bedroom, you were struck down, it was your doom
Annie, are you okay? So, Annie, are you okay? Are you okay, Annie?
You've been hit by, you've been struck by, a smooth criminal
Ow!`,

      `Ow!`,

      `Annie are you okay? Will you tell us that you're okay?
There's a sound at the window, that he struck you, a crescendo, Annie
He came into your apartment, and left bloodstains on the carpet
Then you ran into the bedroom, you were struck down, it was your doom Annie
Annie are you okay? Will you tell us that you're okay?
There's a sound at the window, that he struck you, a crescendo, Annie
He came into your apartment, and left bloodstains on the carpet
And then you ran into the bedroom, you were struck down, it was your doom Annie`,
    ],
    lyricsModified: [
      `As he entered through the casement,  
It was a sound most alarming, swelling in volume like the surging strains of an orchestra reaching its climax.  
He stepped with dreadful intent into her modest dwelling,  
And in his wake, a most grievous stain was left upon the embroidered carpet.  
She, seized with fright, sought refuge beneath the polished mahogany table,  
Yet her trembling limbs did betray her inability to flee.  
He beheld her terror, for she was rendered utterly incapable.  
Thus, in a fit of desperate resolve, she dashed toward her chamber.  
Alas! She was struck down, and fate did decree her doom.`,

      `Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?`,

      `Annie, are you quite well? Will you not grant us reassurance of your condition?  
There was a dreadful sound at the window—he struck with terrible force, a crescendo, dear Annie.  
He entered your apartment, and lo, the bloodstains bear testimony upon the carpet.  
You sought the safety of your chamber, yet cruel fate pursued you; you were struck down, and ruin was upon you.`,

      `Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Thou hast been waylaid, thou hast been set upon by a rogue most artful and treacherous.  
Alas!`,

      `And so they came upon the scene with great haste,  
Entering the threshold as if drawn by some grim force.  
It was a Sunday—a day meant for respite, yet rendered dark by villainy.  
They did attempt to restore her with breath,  
Pressing upon her lifeless lips in hope of revival.  
Yet her heart, frail and faltering, gave forth but the faintest of protests.`,

      `Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?`,

      `Annie, are you quite well? Will you not grant us reassurance of your condition?  
There was a dreadful sound at the window—he struck with terrible force, a crescendo, dear Annie.  
He entered your apartment, and lo, the bloodstains bear testimony upon the carpet.  
You sought the safety of your chamber, yet cruel fate pursued you; you were struck down, and ruin was upon you.  
Annie, pray, are you quite well? So, Annie, are you quite well? Are you unscathed, dear Annie?  
Thou hast been waylaid, thou hast been struck down by a villain most cunning and elusive.  
Alas!`,

      `Alas!`,

      `Annie, are you quite well? Will you not grant us reassurance of your condition?  
There was a dreadful sound at the window—he struck with terrible force, a crescendo, dear Annie.  
He entered your apartment, and lo, the bloodstains bear testimony upon the carpet.  
You sought the safety of your chamber, yet cruel fate pursued you; you were struck down, and ruin was upon you, Annie.  
Annie, are you quite well? Will you not grant us reassurance of your condition?  
There was a dreadful sound at the window—he struck with terrible force, a crescendo, dear Annie.  
He entered your apartment, and lo, the bloodstains bear testimony upon the carpet.  
You sought the safety of your chamber, yet cruel fate pursued you; you were struck down, and ruin was upon you, Annie.`,
    ],
  },
  {
    id: "3",
    number: 3,
    date: "2026-05-04",
    title: "Bohemian Rhapsody",
    artist: "Queen",
    link: "https://www.youtube.com/embed/fJ9rUzIMcZQ",
    style: "Pirate",
    lyricsOriginal: [
      `Is this the real life? Is this just fantasy?
Caught in a landslide, no escape from reality
Open your eyes, look up to the skies and see
I'm just a poor boy, I need no sympathy
Because I'm easy come, easy go
Little high, little low
Any way the wind blows doesn't really matter to me, to me`,
      `Mama, just killed a man
Put a gun against his head, pulled my trigger, now he's dead
Mama, life had just begun
But now I've gone and thrown it all away
Mama, ooh, didn't mean to make you cry
If I'm not back again this time tomorrow
Carry on, carry on as if nothing really matters`,
      `Too late, my time has come
Sends shivers down my spine, body's aching all the time
Goodbye, everybody, I've got to go
Gotta leave you all behind and face the truth
Mama, ooh (any way the wind blows)
I don't wanna die
I sometimes wish I'd never been born at all`,
      `I see a little silhouetto of a man
Scaramouche, Scaramouche, will you do the Fandango?
Thunderbolt and lightning, very, very frightening me
(Galileo) Galileo, (Galileo) Galileo, Galileo Figaro, magnifico
But I'm just a poor boy, nobody loves me
He's just a poor boy from a poor family
Spare him his life from this monstrosity`,
      `Easy come, easy go, will you let me go?
بِسْمِ ٱللَّٰهِ
No, we will not let you go (let him go)
بِسْمِ ٱللَّٰهِ
We will not let you go (let him go)
بِسْمِ ٱللَّٰهِ
We will not let you go (let me go)
Will not let you go (let me go)
Will not let you go (never, never, never, never let me go)
No, no, no, no, no, no, no`,
      `Oh, mamma mia, mamma mia
Mamma mia, let me go
Beelzebub has a devil put aside for me, for me, for me
So you think you can stone me and spit in my eye?
So you think you can love me and leave me to die?
Oh, baby, can't do this to me, baby
Just gotta get out, just gotta get right outta here`,
      `Ooh
Ooh, yeah, ooh, yeah
Nothing really matters, anyone can see
Nothing really matters
Nothing really matters to me
`,
    ],
    lyricsModified: [
      `Be this the true life, or be it but a wild fancy?  
Trapped in the grip o’ the tempest, no escape from the cruel sea!  
Open ye deadlights, gaze up at the heavens ‘n’ see,  
I be but a wretched lad, no sympathy fer me!  
For I come ‘n’ go with the tide,  
Rise up high, sink down low,  
Where’er the wind be blowin’ matters not to me, not to me!`,

      `Arrr, me mother, I’ve slain a man!  
Pressed me pistol to his skull, pulled the trigger, now he be done fer!  
Mother, me life had just begun,  
Yet now I’ve tossed it o’erboard like a chest o’ fool’s gold!  
Mother, arrr, didn’t mean to make ye weep,  
If I don’t return upon the morrow’s tide,  
Sail on, sail on, as if it be naught but a whisper in the wind!`,

      `Too late! Me time be at hand!  
Shivers be runnin’ down me spine, me bones be achin’ like a mast in a storm!  
Farewell, me hearties, I must set sail,  
Leave ye all behind and face the gallows’ noose!  
Mother, arrr (where’er the wind blows),  
I wish not to perish,  
Some nights I be wishin’ I’d ne’er been born at all!`,

      `I spy a tiny silhouette o’ a scallywag!  
Scaramouche, Scaramouche, will ye dance the fandango?  
Thunder and cannon-fire be strikin’ me timbers!  
(Galileo) Galileo, (Galileo) Galileo, Galileo Figaro, magnificent rogue!
But I be but a poor soul, none give a damn fer me!  
He be but a poor soul from a lowly crew,  
Spare him this fate, let him be free!`,

      `Easy come, easy go, will ye let me go?
By Davy Jones’ cursed name,  
Nay! We shall not let ye go! (Let him go!)  
By Davy Jones’ cursed name,  
We shall not let ye go! (Let him go!)  
By Davy Jones’ cursed name,  
We shall not let ye go! (Let me go!)  
Shall not let ye go! (Let me go!)  
Shall not let ye go! (Ne’er, ne’er, ne’er shall we let ye go!)  
Nay, nay, nay, nay, nay, nay, nay!`,

      `Blimey! Mamma mia, mamma mia!  
Mamma mia, set me free!  
Beelzebub’s got a devil markin’ me for the deep,  
For me! For me! For meeeeee!
So ye think ye can strike me and spit in me eye?  
So ye think ye can love me, then leave me to die?  
Arrr, ye scurvy dog, ye can’t do this to me!  
I must break free, I must escape this blasted place!`,

      `Oooooh,  
Oooooh, aye! Oooooh, aye!
Naught be matterin’, any soul can see,  
Naught be matterin’,  
Naught be matterin’ to meeeee...`,
    ],
  },
  {
    id: "2",
    number: 2,
    date: "2026-05-03",
    title: "I write sins not tragedies",
    artist: "Panic! At The Disco",
    link: "https://www.youtube.com/embed/vc6vs-l5dkc",
    style: "Old-timey Gangster",
    lyricsOriginal: [
      `Oh, well imagine
As I'm pacing the pews in a church corridor
And I can't help but to hear
No, I can't help but to hear an exchanging of words`,
      `"What a beautiful wedding
What a beautiful wedding", says a bridesmaid to a waiter
"And, yes, but what a shame
What a shame the poor groom's bride is a whore"`,
      `I chime in with a
"Haven't you people ever heard of closing the goddamn door?"
No, it's much better to face these kinds of things
With a sense of poise and rationality`,
      `I chime in
"Haven't you people ever heard of closing the goddamn door?"
No, it's much better to face these kinds of things
With a sense of`,
      `Well, in fact
Well, I'll look at it this way
I mean, technically, our marriage is saved
Well, this calls for a toast
So pour the champagne`,
      `Oh, well in fact
Well, I'll look at it this way
I mean, technically, our marriage is saved
Well, this calls for a toast
So pour the champagne, pour the champagne`,
      `I chime in with a
"Haven't you people ever heard of closing the goddamn door?"
No, it's much better to face these kinds of things
With a sense of poise and rationality`,
      `I chime in
"Haven't you people ever heard of closing the goddamn door?"
No, it's much better to face these kinds of things
With a sense of poise and rationality`,
      `Again`,
      `I chime in
"Haven't you people ever heard of closing the goddamn door?"
No, it's much better to face these kinds of things
With a sense of poise and rationality`,
      `I chime in
"Haven't you people ever heard of closing the goddamn door?"
No, it's much better to face these kinds of things
With a sense of poise and rationality`,
      `Again`,
    ],
    lyricsModified: [
      `Oh, well, picture this, pal
I'm stompin’ the floorboards in some ritzy joint
And I just can’t help but overhear
Yeah, I just can’t help but overhear some chinwag, see?`,

      `"Ain’t it a swell wedding?
Ain’t it a real swell wedding," says a dame to some sap with a tray
"And yeah, sure, but what a rub
What a rub, 'cause the poor sap's doll is a no-good floozy!"`,

      `So I butt in with a
"Ain’t none of you mugs ever heard of shuttin’ the damn door?"
Nah, it's a damn sight classier to handle this kinda racket
With a little dignity and some wise thinking, capisce?`,

      `I butt in
"Ain’t none of you mugs ever heard of shuttin’ the damn door?"
Nah, it's a damn sight classier to handle this kinda racket
With a little dignity and some wise thinking, see?"`,

      `Well, lookie here
Lemme give it to ya straight
I mean, technically, the old ball and chain is still locked up tight
This calls for some hooch
So pass the bubbly, see?`,

      `Yeah, well, in fact
Lemme give it to ya straight
I mean, technically, the old ball and chain is still locked up tight
This calls for some hooch
So pass the bubbly, pass the bubbly`,

      `I butt in with a
"Ain’t none of you mugs ever heard of shuttin’ the damn door?"
Nah, it's a damn sight classier to handle this kinda racket
With a little dignity and some wise thinking, capisce?`,

      `I butt in
"Ain’t none of you mugs ever heard of shuttin’ the damn door?"
Nah, it's a damn sight classier to handle this kinda racket
With a little dignity and some wise thinking, capisce?"`,

      `Once more`,

      `I butt in
"Ain’t none of you mugs ever heard of shuttin’ the damn door?"
Nah, it's a damn sight classier to handle this kinda racket
With a little dignity and some wise thinking, capisce?"`,

      `I butt in
"Ain’t none of you mugs ever heard of shuttin’ the damn door?"
Nah, it's a damn sight classier to handle this kinda racket
With a little dignity and some wise thinking, see?"`,

      `Once more`,
    ],
  },
  {
    id: "1",
    number: 1,
    date: "2026-05-02",
    title: "Poker Face",
    artist: "Lady Gaga",
    link: "https://www.youtube.com/embed/bESGLojNYSo",
    style: "Cyberpunk",
    lyricsOriginal: [
      `I wanna hold 'em like they do in Texas, please
Fold 'em, let 'em hit me, raise it, baby, stay with me (I love it)
LoveGame intuition, play the cards with spades to start
And after he's been hooked, I'll play the one that's on his heart`,
      `Oh, whoa-oh, oh, oh
Oh-oh-oh-oh-oh-oh
I'll get him hot, show him what I got
Oh, whoa-oh, oh, oh
Oh-oh-oh-oh-oh-oh
I'll get him hot, show him what I got`,
      `Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)
Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)`,
      `P-p-p-poker face, f-f-fuck her face (mum-mum-mum-mah)
P-p-p-poker face, f-f-fuck her face (mum-mum-mum-mah)`,
      `I wanna roll with him, a hard pair we will be (hey)
A little gamblin' is fun when you're with me (I love it, woo)
Russian roulette is not the same without a gun
And baby, when it's love, if it's not rough, it isn't fun (fun)`,
      `Oh, whoa-oh, oh, oh
Oh-oh-oh-oh-oh-oh
I'll get him hot, show him what I got
Oh, whoa-oh, oh, oh
Oh-oh-oh-oh-oh-oh
I'll get him hot, show him what I got`,
      `Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)
Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)`,
      `P-p-p-poker face, f-f-fuck her face (mum-mum-mum-mah)
P-p-p-poker face, f-f-fuck her face (mum-mum-mum-mah)
(Mum-mum-mum-mah)
(Mum-mum-mum-mah)`,
      `I won't tell you that I love you, kiss or hug you
'Cause I'm bluffin' with my muffin
I'm not lyin', I'm just stunnin' with my love-glue-gunnin'
Just like a chick in the casino
Take your bank before I pay you out
I promise this, promise this
Check this hand 'cause I'm marvelous`,
      `Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)
Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)
Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)
Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)
Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)
Can't read my, can't read my
No, he can't read my poker face
(She's got me like nobody)`,
      `P-p-p-poker face, p-p-poker face
P-p-p-poker face, f-f-fuck her face (she's got me like nobody)
P-p-p-poker face, f-f-fuck her face (mum-mum-mum-mah)
P-p-p-poker face, f-f-fuck her face (mum-mum-mum-mah)
P-p-p-poker face, f-f-fuck her face (mum-mum-mum-mah)
P-p-p-poker face, f-f-fuck her face (mum-mum-mum-mah)`,
    ],
    lyricsModified: [
      `I wanna play 'em like they do in the neon zones, yeah
Stack the deck, let the credits roll, keep the system wired in (I feel it)
Synapse spike, read the odds, let the spades break first
And once he's caught in my code, I'll crash his heartdrive`,

      `Oh, whoa-oh, oh, oh
Oh-oh-oh-oh-oh-oh
Burn his firewalls, show him my source
Oh, whoa-oh, oh, oh
Oh-oh-oh-oh-oh-oh
Burn his firewalls, show him my source`,

      `Can't decrypt me, can't decrypt me
No, he can't crack my steel mask
(Encrypted like nobody)
Can't decrypt me, can't decrypt me
No, he can't crack my steel mask
(Encrypted like nobody)`,

      `S-s-s-steel mask, f-f-fracture data (glitch-glitch-glitch-glow)
S-s-s-steel mask, f-f-fracture data (glitch-glitch-glitch-glow)`,

      `I wanna ride the betstream, stack the odds, let it roll (yeah)
A little risk feels right when I'm in control (I see it, woo)
Russian roulette ain't worth it unless the stakes are high
And baby, in this world, if it's too safe, it ain't real (real)`,

      `Oh, whoa-oh, oh, oh
Oh-oh-oh-oh-oh-oh
Burn his firewalls, show him my source
Oh, whoa-oh, oh, oh
Oh-oh-oh-oh-oh-oh
Burn his firewalls, show him my source`,

      `Can't decrypt me, can't decrypt me
No, he can't crack my steel mask
(Encrypted like nobody)
Can't decrypt me, can't decrypt me
No, he can't crack my steel mask
(Encrypted like nobody)`,

      `S-s-s-steel mask, f-f-fracture data (glitch-glitch-glitch-glow)
S-s-s-steel mask, f-f-fracture data (glitch-glitch-glitch-glow)
(Glitch-glitch-glitch-glow)
(Glitch-glitch-glitch-glow)`,

      `I won't drop a tell, no signal, no pulse
'Cause I'm ghostin’ while I’m hostin’
I don’t bluff, I just buffer till my jackpot loads in
Just like a shark in the server
Drain your stacks before the mainframe resets
I promise this, promise this
Check the screen ‘cause I'm dangerous`,

      `Can't decrypt me, can't decrypt me
No, he can't crack my steel mask
(Encrypted like nobody)
Can't decrypt me, can't decrypt me
No, he can't crack my steel mask
(Encrypted like nobody)
Can't decrypt me, can't decrypt me
No, he can't crack my steel mask
(Encrypted like nobody)
Can't decrypt me, can't decrypt me
No, he can't crack my steel mask
(Encrypted like nobody)`,

      `S-s-s-steel mask, p-p-steel mask
S-s-s-steel mask, f-f-fracture data (encrypted like nobody)
S-s-s-steel mask, f-f-fracture data (glitch-glitch-glitch-glow)
S-s-s-steel mask, f-f-fracture data (glitch-glitch-glitch-glow)
S-s-s-steel mask, f-f-fracture data (glitch-glitch-glitch-glow)
S-s-s-steel mask, f-f-fracture data (glitch-glitch-glitch-glow)`,
    ],
  },
];
